import { render, staticRenderFns } from "./ProfileCard.vue?vue&type=template&id=144994a4&scoped=true"
import script from "./ProfileCard.vue?vue&type=script&lang=ts"
export * from "./ProfileCard.vue?vue&type=script&lang=ts"
import style0 from "./ProfileCard.vue?vue&type=style&index=0&id=144994a4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "144994a4",
  null
  
)

export default component.exports